import { makeStyles } from 'tss-react/mui';

export const useCatalogBannerSortableTileStyles = makeStyles()(() => ({
  tile: {
    position: 'relative',
    cursor: 'grab',
    '&:active': { cursor: 'grabbing' },
    '& .drag-handle': {
      opacity: 0,
      transition: 'opacity 0.2s ease-in-out',
    },
    '&:hover .drag-handle, &:focus-within .drag-handle': {
      opacity: 1,
    },
  },
  dragHandle: {
    position: 'absolute',
    top: 6,
    left: 6,
    zIndex: 2,
    display: 'flex',
    pointerEvents: 'none',
  },
}));
